const system = {
  loading: "در حال بررسی جداسازی داده‌های برنامه برای هر کاربر…",
  unavailable: {
    title: "وضعیت سیستم در دسترس نیست",
    retry: "تلاش دوباره",
    fetchFailed: "دریافت وضعیت سیستم ناموفق بود.",
    healthFailed: "بررسی سلامت سیستم ناموفق بود.",
  },
  header: {
    title: "معماری و سلامت سیستم",
    description: "این صفحه سراسری و فقط برای مدیر ارشد است. بررسی می‌کند که هر رکورد برنامه — شامل منابع، فیلترها، ترجیحات هوش مصنوعی، پست‌های پایش‌شده، وضعیت Inbox و مقصدها — متعلق به یک عضو باشد. اعتبارها همچنان در بخش «مقصدهای من» هر عضو مدیریت می‌شوند.",
    scope: "محدوده مدیریت سیستم",
    notice: "اعلان سلامت سیستم",
    cutoverTitle: "گذار کامل مالکیت داده‌های برنامه هنوز انجام نشده است",
    cutoverDescription: "هنوز به یک انتشار هماهنگ پایگاه داده و backend نیاز است تا داشتن مالک برای هر منبع، فیلتر، تنظیم هوش مصنوعی، پست پایش‌شده، آیتم Inbox و مقصد به‌صورت ساختاری اجباری شود.",
    supabaseEndpoint: "نقطه اتصال Supabase:",
    notConfigured: "تنظیم نشده",
    refresh: "به‌روزرسانی سلامت",
  },
  overview: {
    backendLabel: "اجرای backend",
    backendTitle: "PostgreSQL نرمال‌شده",
    backendActive: "backend فعال است",
    backendUnavailable: "backend در دسترس نیست",
    architectureLabel: "معماری چندکاربره",
    architectureTitle: "جداسازی فضای کاری",
    isolated: "داده‌های شخصی جدا هستند",
    cutoverIncomplete: "گذار کامل نشده",
    automationLabel: "اتوماسیون",
    automationTitle: "جمع‌آوری و پاک‌سازی",
    jobsActive: "کارها فعال‌اند",
    automationIncomplete: "اتوماسیون کامل نیست",
    securityLabel: "امنیت داده",
    securityTitle: "جدول‌های تحت مالکیت backend",
    protected: "{{protected}}/{{expected}} محافظت‌شده",
  },
  monitoring: {
    title: "داده‌های پایش شخصی",
    description: "منابع و پست‌های جمع‌آوری‌شده تلگرام برای هر عضو جداگانه ذخیره می‌شوند، حتی اگر دو عضو یک کانال عمومی را پایش کنند.",
    sourceChannels: "کانال‌های منبع",
    monitoredPosts: "پست‌های پایش‌شده · ۲۴ ساعت",
  },
  workspace: {
    title: "داده‌های فضای کاری شخصی",
    description: "فرایند Inbox و تنظیمات انتشار نیز بر اساس مالک جدا می‌شوند. شمارش‌های زیر فقط شاخص‌های تجمیعی سلامت سیستم هستند.",
    destinationTargets: "مقصدها",
    inboxRows: "ردیف‌های فرایند Inbox",
    publishedWorkflow: "وضعیت‌های انتشار",
    supabaseMembers: "اعضای Supabase",
    legacyMembers: "اعضای قدیمی",
    unownedRows: "ردیف‌های بدون مالک",
    publishStates: "وضعیت انتشار برای هر کاربر",
    durableIdentities: "هویت‌های پایدار فعال",
    usernameOwned: "فضاهای کاری متعلق به نام کاربری",
    shouldRemainZero: "باید ۰ باقی بماند",
    owners_one: "{{formattedCount}} مالک",
    owners_other: "{{formattedCount}} مالک",
  },
  runtime: {
    title: "مرزهای داده در زمان اجرا",
    description: "همه جدول‌های برنامه شخصی هستند. فقط رکورد سازگاری قدیمی در سطح سیستم است و مرورگرها دسترسی مستقیم برای نوشتن در پایگاه داده ندارند.",
    scopes: { personal: "شخصی", compatibility: "سازگاری" },
    tables: {
      source_channels: "منابع شخصی",
      filters: "فیلترهای شخصی",
      destination_targets: "مقصدهای شخصی",
      ai_settings: "تنظیمات شخصی هوش مصنوعی",
      posts: "پست‌های پایش‌شده شخصی",
      user_inbox_items: "وضعیت شخصی Inbox",
      curator_settings: "سازگاری قدیمی",
    },
  },
  isolation: {
    title: "بررسی‌های جداسازی فضای کاری",
    description: "این بررسی‌ها تأیید می‌کنند که داده‌ای از برنامه بیرون از فضای کاری یک عضو وجود نداشته باشد.",
    ownershipTitle: "مالکیت کامل داده‌های برنامه",
    ownershipDescription: "منابع، فیلترها، تنظیمات هوش مصنوعی، پست‌ها و مقصدها باید مالک داشته باشند.",
    inboxTitle: "جداسازی Content Inbox",
    inboxDescription: "وضعیت بررسی/ویرایش/انتشار فقط به پست‌های همان مالک متصل می‌شود.",
    orphanTitle: "بررسی داده‌های بدون مالک",
    orphanDescription: "هر ردیف تولیدی برنامه باید مالک داشته باشد.",
    ready: "آماده",
    missing: "ناقص",
    cutoverPending: "گذار در انتظار است",
    noOrphans: "داده بدون مالک وجود ندارد",
    unowned: "{{count}} بدون مالک",
    note: "تعریف منابع، فیلترها، ترجیحات هوش مصنوعی، متن پست‌های پایش‌شده، وضعیت، تاریخچه و خطاها هرگز تنظیمات عمومی محسوب نمی‌شوند. اعتبار ربات‌های تلگرام در سکرت‌های Vault مختص کاربر باقی می‌مانند.",
  },
  automation: {
    title: "اتوماسیون جمع‌آوری",
    description: "زمان‌بند مالکان دارای منابع فعال را شناسایی می‌کند و جمع‌آوری را در فضای کاری جداگانه هر عضو با استفاده از فیلترها و سوابق پست همان عضو اجرا می‌کند.",
    cronInstalled: "pg_cron نصب است",
    cronMissing: "pg_cron نصب نیست",
    netInstalled: "pg_net نصب است",
    netMissing: "pg_net نصب نیست",
    empty: "هیچ کار جمع‌آوری TGReposter پیدا نشد.",
    jobs: { import: "ورود Source Inbox", cleanup: "پاک‌سازی گردشی Inbox" },
    schedules: { everyFiveMinutes: "هر ۵ دقیقه", everyHour: "هر ساعت" },
    succeeded: "موفق",
    active: "فعال",
    lastRunFailed: "آخرین اجرا ناموفق بود",
    disabled: "غیرفعال",
    lastRun: "آخرین اجرا: {{time}}",
    noRun: "هیچ اجرایی ثبت نشده",
  },
  security: {
    title: "اجرای مدیریت‌شده با migration و امن به‌صورت پیش‌فرض",
    description: "تغییرات ساختاری از طریق migrationهای Supabase نسخه‌بندی می‌شوند. همه تنظیمات و محتوای برنامه متعلق به اعضا هستند و نوشتن‌های حساس از مسیرهای backend احراز هویت‌شده انجام می‌شوند، نه با دسترسی مستقیم مرورگر به پایگاه داده.",
  },
} as const;

export default system;
